module.exports = {
	"articleTitle1": "Community discusses future display of Washtenaw mammoth ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Conor O'Neill's",
	"articleLink1": "https://www.michigandaily.com/section/news/mammoth-display-discussed-forum",
	"articleLink2": "https://www.michigandaily.com/section/news/events-nov-18",
	"articleSnippet1": "Jan 27, 2016 ... The discussion, held at Conor O'Neill's Traditional Irish Pub as one of UMNH's \nmonthly science café series, consisted of brief presentations ...",
	"articleSnippet2": "Nov 17, 2015 ... Where: Conor O'Neill's Traditional Irish Pub. Photoshop workshop. What: The \nKnowlege Navigation Center will host a Photoshop 101 course to ...",
	"foodRecommendations": [],
	"articleTitle2": "Events: Nov. 18 ",
	"address": "318 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278807,
		"lng": -83.749029
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/conoroneills.json
// module id = 855
// module chunks = 0